export enum ReferentialType {
  ASSETTYPES,
  GROUPTYPES,
  PROFESSIONTYPES,
  EMAILTEMPLATETYPES,
  RECYCLINGFLAGS,
  REJECTIONFLAGS,
  WAITINGFLAGS,
  VAT,
  DEDUCTIONTYPE,
  INVOICEPPRTYPE,
  EXPENSEFAMILYTYPE,
  TYPOLOGIE,
  COMPANY,
  TREELEVEL,
  EXPENSETRADETYPE,
}
